import axios, { AxiosResponse } from "axios";

/**
 * Publishes or unpublishes a Tixologi event by writing its `inactive` flag
 * (unpublished = hidden from every public surface and unsellable).
 *
 * The body carries `inactive` and nothing else. That is only safe because
 * ticketing-api keeps the images and media a partial PUT does not carry
 * (Tixologi-Inc/ticketing-api-2.0#1104); before that fix this exact body
 * hard-deleted the event's media.
 */
export async function setTixologiEventPublished(
  eventId: string | number,
  published: boolean,
  token: string | undefined
): Promise<AxiosResponse> {
  return axios.put(
    process.env.NEXT_PUBLIC_TIXOLOGI_API_URL + `/events/${eventId}`,
    { inactive: !published },
    { headers: { Authorization: `Bearer ${token}` } }
  );
}
